import React, { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import PersonIcon from '@mui/icons-material/Person';
import FactoryIcon from '@mui/icons-material/Factory';
import { TabsUI } from '../../Interface';
import CompanyAddDialogFields from './CompanyAddDialogFields';
import { BpType } from '../../../config/company';

const CompanyAddDialogTabs = (props) => {
  const { setFieldValue } = useFormikContext();
  const [activeTab, setActiveTab] = useState(0);
  const [expandedAccordions, setExpandedAccordions] = useState({
    address: true,
    contact: true,
  });

  const tabs = [
    {
      id: 0,
      name: (
        <Stack direction="row" alignItems="center" spacing={1}>
          <FactoryIcon fontSize="small" />
          <Typography>Cég</Typography>
        </Stack>
      ),
      content: (
        <CompanyAddDialogFields {...props} expandedAccordionsState={{ expandedAccordions, setExpandedAccordions }} />
      ),
      type: BpType.COMPANY,
    },
    {
      id: 1,
      name: (
        <Stack direction="row" alignItems="center" spacing={1}>
          <PersonIcon fontSize="small" />
          <Typography>Magánszemély</Typography>
        </Stack>
      ),
      content: (
        <CompanyAddDialogFields {...props} expandedAccordionsState={{ expandedAccordions, setExpandedAccordions }} />
      ),
      type: BpType.PRIVATE,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);

    const type = tabs[tabIndex].type;

    setFieldValue('bpType', type);
    setFieldValue('hunTaxNumber', '');
    setFieldValue('contact', [
      {
        name: '',
        phoneNumber: '',
        email: '',
      },
    ]);
  };

  return (
    <Box mt={1}>
      <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
        {tabs.map((tab, index) => (
          <div key={index} name={tab.name}>
            {index === activeTab ? tab.content : null}
          </div>
        ))}
      </TabsUI>
    </Box>
  );
};

export default CompanyAddDialogTabs;
